import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { useHistory } from "react-router-dom";
import "./index.scss";
export default function SidebarMenu({
  image,
  hoverImage,
  activeImage,
  name,
  onHover,
  activeIndex,
  index,
  onLeave,
  onClick,
  path,
  toggleDrawer,
}) {
  const history = useHistory();

  return (
    <Stack
      className="_cp __sidebar_menu"
      onClick={() => {
        onClick(index);
        toggleDrawer(false);
        history.push(path);
      }}
      direction="row"
      alignItems="flex-end"
      gap="0px"
    >
      {activeIndex === index ? (
        <Box
          style={{
            height: "21px",
            width: "2px",
            marginRight:"10px",
            backgroundColor: "#FFEE20",
          }}
        />
      ) : (
        <div style={{ width: "12px" }} />
        )}
      <Stack gap="10px" direction="row" alignItems="flex-end">
        <img style={{ width: "20px" }} src={image} alt={name} />
        <Typography
          className={
            "_cp" +
            (activeIndex === index
              ? " __sidebar_menu_active"
              : " __sidebar_menu_item") +
            " fs-14 "
          }
        >
          {name}
        </Typography>
      </Stack>
    </Stack>
  );
}
